import { BasicClient } from '@/utils/httpClient';

export default class Pickup {
  client: BasicClient
  constructor() {
    this.client = new BasicClient();
  }

  editPickup(params: any) {
    const { id, doc } = params
    return this.client.exec(`/pickup-eforms/${id}`, 'PUT', doc)
  }

  deletePickup(params: any) {
    const { id } = params
    return this.client.exec(`/pickup-eforms/${id}`, 'DELETE')
  }

  enablePickup(params: any) {
    return this.client.exec('/pickup-eforms', 'POST', params)
  }
}